import { useMeetOverlays } from '../../features/meet/MeetOverlaysProvider';
import { useMeetPermissionsContext } from '../../features/meet/MeetPermissionsProvider';
import { MeetBackgroundOption } from '../../features/meet/types';
import { Button, ConfirmDialog, Modal } from '../../shared/ui';
import { PermissionsModal } from '../../components/permissions-modal';
import { BackgroundModal } from '../../components/modals/backgroundModal';
import { MacDeckSelectModal } from '../../components/tools/mac-cards/mac-deck-select-modal';

interface MeetOverlaysProps {
  settingsModal: React.ReactNode;
  isPsychologist: boolean;
  backgrounds: MeetBackgroundOption[];
  isConfirmStopSupervisorOpen: boolean;
  isConfirmStartSupervisorOpen: boolean;
  sharingPersonName: string;
  onConfirmMacDeckModal: () => void;
  sendMacCardsOpen?: (data: {
    show: boolean;
    cover: string;
    color: string;
    result: { name: string; value: string[] };
  }) => void;
  onCloseInstruction: () => void;
  onCloseBackgroundModal: () => void;
  onBlurBackground: () => void;
  onSelectBackground: (src: string) => void;
  onRejectStopSupervisor: () => void;
  onConfirmStopSupervisor: () => void;
  onRejectStartSupervisorGroup: () => void;
  onConfirmStartSupervisorGroup: () => void;
  onConfirmScreenShare: () => void;
  onCancelScreenShare: () => void;
}

export function MeetOverlays({
  settingsModal,
  isPsychologist,
  backgrounds,
  isConfirmStopSupervisorOpen,
  isConfirmStartSupervisorOpen,
  sharingPersonName,
  onConfirmMacDeckModal,
  sendMacCardsOpen,
  onCloseInstruction,
  onCloseBackgroundModal,
  onBlurBackground,
  onSelectBackground,
  onRejectStopSupervisor,
  onConfirmStopSupervisor,
  onRejectStartSupervisorGroup,
  onConfirmStartSupervisorGroup,
  onConfirmScreenShare,
  onCancelScreenShare,
}: MeetOverlaysProps) {
  const overlays = useMeetOverlays();
  const permissions = useMeetPermissionsContext();

  return (
    <>
      {overlays.openSettings && settingsModal}
      {isPsychologist && (
        <MacDeckSelectModal
          isOpen={overlays.macDeckModalOpen}
          onClose={() => overlays.setMacDeckModalOpen(false)}
          onConfirm={onConfirmMacDeckModal}
          sendMacCardsOpen={sendMacCardsOpen}
        />
      )}
      {permissions.showPermissionsModal && (
        <PermissionsModal
          open={permissions.showPermissionsModal}
          onClose={() => permissions.setShowPermissionsModal(false)}
          onRequestPermissions={permissions.reRequestPermissions}
        />
      )}
      <Modal
        isOpen={Boolean(overlays.showModalInstruct)}
        size="sm"
        onClose={onCloseInstruction}
        footer={
          <Button size="md" fullWidth onClick={onCloseInstruction}>
            Понятно
          </Button>
        }
      >
        <p>{overlays.showModalInstruct}</p>
      </Modal>
      <BackgroundModal
        isOpen={overlays.showBackgroundModal}
        onClose={onCloseBackgroundModal}
        onBlur={onBlurBackground}
        backgrounds={backgrounds}
        onSelect={onSelectBackground}
      />
      <ConfirmDialog
        isOpen={isConfirmStopSupervisorOpen}
        sheetOnMobile
        title="Остановить ИИ-супервизора?"
        message="Отключение остановит работу инструмента и анализ сессии."
        cancelText="Продолжить"
        confirmText="Остановить"
        onCancel={onRejectStopSupervisor}
        onConfirm={onConfirmStopSupervisor}
      />
      <ConfirmDialog
        isOpen={overlays.showScreenShareConflictModal}
        sheetOnMobile
        title={`${sharingPersonName} уже показывает экран`}
        message="Если вы начнете показ, текущая демонстрация будет остановлена. Продолжить?"
        confirmText="Начать свой показ"
        onCancel={onCancelScreenShare}
        onConfirm={onConfirmScreenShare}
      />
      <ConfirmDialog
        isOpen={isConfirmStartSupervisorOpen}
        sheetOnMobile
        title="Включить ИИ-супервизор?"
        message="Запись групповой сессии будет анализироваться ИИ-супервизором. Участникам запрашивать разрешение не требуется."
        confirmText="Включить"
        onCancel={onRejectStartSupervisorGroup}
        onConfirm={onConfirmStartSupervisorGroup}
      />
    </>
  );
}
